<template>
    <div class="w-full p-4">
      <div class="flex">
        <div class="text-center sm:text-left">
          Para continuar, por favor complete los siguientes campos con su
          información
        </div>
      </div>
  
      
    </div>
  </template>
  <script setup>

  
  </script>